import { render, staticRenderFns } from "./IdeaBox.vue?vue&type=template&id=04e57ec2&scoped=true&"
import script from "./IdeaBox.vue?vue&type=script&lang=ts&"
export * from "./IdeaBox.vue?vue&type=script&lang=ts&"
import style0 from "./IdeaBox.vue?vue&type=style&index=0&id=04e57ec2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e57ec2",
  null
  
)

export default component.exports